import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-497acd1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "panelheader" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Breakdown", -1))
const _hoisted_4 = { "aria-hidden": "true" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_6 = {
  id: "breakdowntModal",
  class: "panleBody scrollBar border"
}
const _hoisted_7 = {
  key: 1,
  id: "period-message-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["c4c-modal", [_ctx.isBreakdownfrom7Day? 'seven-day': '']])
    }, [
      _createElementVNode("header", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_4, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_neu_card, {
          color: "plain-0",
          class: "p-0 m-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_neu_table, null, {
              default: _withCtx(() => [
                (_ctx.isBreakdownfrom7Day)
                  ? (_openBlock(), _createBlock(_component_neu_table_row, {
                      key: 0,
                      columns: _ctx.columnHeaders,
                      header: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                          return (_openBlock(), _createBlock(_component_neu_table_heading, {
                            key: column,
                            icon: _ctx.columnIcons[column],
                            slot: column,
                            style: {"padding-top":"25px !important"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.columnDisplayNames[column]), 1)
                            ]),
                            _: 2
                          }, 1032, ["icon", "slot"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["columns"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_neu_table_body, { align: "left" }, {
                  default: _withCtx(() => [
                    (_ctx.premLaborBreakdownInput != null && _ctx.premLaborBreakdownInput.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.premLaborBreakdownInput, (premLbr, index) => {
                          return (_openBlock(), _createBlock(_component_neu_table_row, {
                            columns: _ctx.columnHeaders,
                            key: premLbr,
                            class: _normalizeClass([premLbr.IsHeadingRow && _ctx.isBreakdownfrom7Day ? 'headingRow': ''])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_neu_label, {
                                slot: "Key",
                                class: _normalizeClass([index == (_ctx.premLaborBreakdownInput.length - 1) && _ctx.isBreakdownfrom7Day ? 'totalValue': '',
                                                    (premLbr.IsHeadingRow && index != (_ctx.premLaborBreakdownInput.length - 1) && _ctx.isBreakdownfrom7Day ) ? 'headingRowTitle': '',
                                                    !premLbr.IsHeadingRow && _ctx.isBreakdownfrom7Day  ? 'deptTitle': ''])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(premLbr.Key), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"]),
                              _createVNode(_component_neu_label, {
                                slot: "Value",
                                class: _normalizeClass([index == (_ctx.premLaborBreakdownInput.length - 1) && _ctx.isBreakdownfrom7Day  ? 'totalValue': ''])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(premLbr.Value), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"]),
                              (_ctx.isBreakdownfrom7Day)
                                ? (_openBlock(), _createBlock(_component_neu_label, {
                                    key: 0,
                                    slot: "Name",
                                    class: _normalizeClass([index == (_ctx.premLaborBreakdownInput.length - 1) && _ctx.isBreakdownfrom7Day  ? 'totalValue': ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(premLbr.Name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))
                                : _createCommentVNode("", true),
                              (_ctx.isBreakdownfrom7Day)
                                ? (_openBlock(), _createBlock(_component_neu_label, {
                                    key: 1,
                                    slot: "LastCancelled",
                                    class: _normalizeClass([index == (_ctx.premLaborBreakdownInput.length - 1) && _ctx.isBreakdownfrom7Day  ? 'totalValue': ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.displayDate(premLbr.LastCancelled)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["columns", "class"]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("p", _hoisted_7, "No data available."))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ], 2)
  ]))
}